import { UsuarioPermissaoModule } from './features/manutencao/usuario-permissao/usuario-permissao.module';
// import { ModuloRelatorio } from './features/manutencao/modulo-relatorio/models/modulo-relatorio';
import { Routes } from '@angular/router';
import { FullComponent } from './template/layouts/full/full.component';
import { AppBlankComponent } from './template/layouts/blank/blank.component';
import { HomeComponent } from './features/home/home.component';
import { AcessibilidadeComponent } from './features/acessibilidade/acessibilidade.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'autenticacao/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'login',
        redirectTo: 'autenticacao/login',
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'acessibilidade',
        component: AcessibilidadeComponent,
        pathMatch: 'full',
        data: {
          title: 'Acessibilidade',
          urls: [
            { title: 'Business Intelligence - B.I', url: '/home' },
            { title: 'Acessibilidade' },
          ],
        },
      },
      {
        path: '',
        redirectTo: '/dashboards/dashboard1',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        redirectTo: '/dashboards/dashboard1',
        pathMatch: 'full',
      },
      // {
      //   path: 'relatorio',
      //   loadChildren: () =>
      //     import('./features/manutencao/relatorio/relatorio.module').then(
      //       (m) => m.RelatorioModule
      //     ),
      // },
      {
        path: 'entidade',
        loadChildren: () =>
          import('./features/manutencao/entidade/entidade.module').then(
            (m) => m.EntidadeModule
          ),
      },
      {
        path: 'usuarios/usuario',
        loadChildren: () =>
          import('./features/manutencao/usuario/usuario.module').then(
            (m) => m.UsuarioModule
          ),
      },
      {
        path: 'parametro/modulo',
        loadChildren: () =>
          import('./features/manutencao/modulo/modulo.module').then(
            (m) => m.ModuloModule
          ),
      },
      {
        path: 'parametro/modulo-tabela',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-tabela/modulo-tabela.module'
          ).then((m) => m.ModuloTabelaModule),
      },
      {
        path: 'parametro/modulo-processamento',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-processamento/modulo-processamento.module'
          ).then((m) => m.ModuloProcessamentoModule),
      },
      {
        path: 'parametro/modulo-disponibilizar-gestor',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-disponibilizar-gestor/modulo-disponibilizar-gestor.module'
          ).then((m) => m.ModuloDisponibilizarGestorModule),
      },
      {
        path: 'parametro/modulo-integracao-consultas',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-integracao-consultas/modulo-integracao-consultas.module'
          ).then((m) => m.ModuloIntegracaoConsultasModule),
      },
      {
        path: 'parametro/configuracao-sistema',
        loadChildren: () =>
          import(
            './features/manutencao/configuracao-sistema/configuracao-sistema.module'
          ).then((m) => m.ConfiguracaoSistemaModule),
      },
      {
        path: 'parametro/modulo-processamento-log',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-processamento-log/modulo-processamento-log.module'
          ).then((m) => m.ModuloProcessamentoLogModule),
      },
      {
        path: 'parametro/modulo-processamento-tabela',
        loadChildren: () =>
          import(
            './features/manutencao/modulo-processamento-tabela/modulo-processamento-tabela.module'
          ).then((m) => m.ModuloProcessamentoTabelaModule),
      },
      // {
      //   path: 'parametro/modulo-relatorio',
      //   loadChildren: () =>
      //     import(
      //       './features/manutencao/modulo-relatorio/modulo-relatorio.module'
      //     ).then((m) => m.ModuloRelatorioModule),
      // },
      {
        path: 'parametro/bancodedados',
        loadChildren: () =>
          import('./features/manutencao/sistema/sistema.module').then(
            (m) => m.SistemaModule
          ),
      },
      {
        path: 'parametro/menu',
        loadChildren: () =>
          import('./features/manutencao/menu/menu.module').then(
            (m) => m.MenuModule
          ),
      },
      {
        path: 'parametro/sub-menu',
        loadChildren: () =>
          import('./features/manutencao/sub-menu/sub-menu.module').then(
            (m) => m.SubMenuModule
          ),
      },
      {
        path: 'analise',
        loadChildren: () =>
          import(
            './features/manutencao/analise/analise.module'
          ).then((m) => m.AnaliseModule),
      },
      // {
      //   path: 'tipo-relatorio',
      //   loadChildren: () =>
      //     import(
      //       './features/manutencao/tipo-relatorio/tipo-relatorio.module'
      //     ).then((m) => m.TipoRelatorioModule),
      // },
      {
        path: 'usuarios/usuario-permissao',
        loadChildren: () =>
          import(
            './features/manutencao/usuario-permissao/usuario-permissao.module'
          ).then((m) => m.UsuarioPermissaoModule),
      },
      {
        path: 'usuarios/grupo-permissao',
        loadChildren: () =>
          import(
            './features/manutencao/grupo-permissao/grupo-permissao.module'
          ).then((m) => m.GrupoPermissaoModule),
      },
      {
        path: 'log-auditoria',
        loadChildren: () =>
          import(
            './features/manutencao/log-auditoria/log-auditoria.module'
          ).then((m) => m.LogAuditoriaModule),
      },
      {
        path: 'demo-custom',
        loadChildren: () =>
          import('./structure/demo-custom/demo-custom.module').then(
            (m) => m.DemoCustomModule
          ),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./template/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: 'material',
        loadChildren: () =>
          import('./template/material-component/material.module').then(
            (m) => m.MaterialComponentsModule
          ),
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./template/apps/apps.module').then((m) => m.AppsModule),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./template/forms/forms.module').then((m) => m.FormModule),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./template/tables/tables.module').then((m) => m.TablesModule),
      },
      {
        path: 'tree',
        loadChildren: () =>
          import('./template/tree/tree.module').then((m) => m.TreeModule),
      },
      {
        path: 'datatables',
        loadChildren: () =>
          import('./template/datatables/datatables.module').then(
            (m) => m.DataTablesModule
          ),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./template/pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./template/widgets/widgets.module').then(
            (m) => m.WidgetsModule
          ),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./template/charts/chartslib.module').then(
            (m) => m.ChartslibModule
          ),
      },
      {
        path: 'multi',
        loadChildren: () =>
          import('./template/multi-dropdown/multi-dd.module').then(
            (m) => m.MultiModule
          ),
      },
    ],
  },
  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'authentication',
        loadChildren: () =>
          import('./features/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'authentication/register',
        loadChildren: () =>
          import('./features/manutencao/usuario/usuario.module').then(
            (m) => m.UsuarioModule
          ),
      },
      {
        path: 'pagina-gestor',
        loadChildren: () =>
          import(
            './features/manutencao/pagina-gestor/pagina-gestor.module'
          ).then((m) => m.RelatorioFinalModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/404',
  },
];
